import { useMutation, useQuery } from '@tanstack/react-query';

import { getPlatforms, updateBrands } from 'src/api/cms';
import { queryClient } from 'src/services/react-query/query-client';

export const useGetPlatformsData = ({ withInactive = false } = {}) => {
  const { data, isPending } = useQuery({
    queryKey: ['platforms'],
    queryFn: () => getPlatforms(),
    gcTime: Infinity,
    select: withInactive
      ? undefined
      : (platforms) =>
          platforms
            .map((platform) => ({
              ...platform,
              brands: platform.brands.filter((brand) => brand.cmsStatus !== 'inactive'),
            }))
            .filter((platform) => platform.brands.length > 0),
  });

  return {
    data,
    isInProgress: isPending,
  };
};

export const useUpdateBrandsAction = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: updateBrands,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['platforms'] }),
  });

  return {
    updateBrands: mutateAsync,
    isInProgress: isPending,
  };
};
